<script>
  import WithPattern from "../../atoms/WithPattern.svelte";
  import Button from "../../atoms/Button.svelte";
  import blackTee from "../../assets/renders/blackTee.png";
  import stickerSet from "../../assets/renders/stickerSet.png";
  import { getBreakpoint } from "../../utilities";

  export let link;

  let width;

  const radiateAdViewBoxMap = {
    sm: "155 -125 250 379",
    md: "0 -165 624 379",
    lg: "0 -160 624 379",
    xl: "0 -160 624 379"
  };

  const getSVGViewBox = (width) => {
    switch (link.pattern) {
      case "radiate":
        return radiateAdViewBoxMap[getBreakpoint(width)];
      default:
        return null;
    }
  };

  $: viewBox = getSVGViewBox(width);
</script>

<svelte:window bind:innerWidth={width} />

<a
  href="https://shop.obama.org/"
  target="_blank"
  class="overflow-x-hidden overflow-y-hidden bg-yellow"
  id={`search-ad-${link.title ? link.title.replace(/\W/g, "") : ""}`}
>
  <WithPattern name={link.pattern} pathColor={link.pathColor} patternViewBox={viewBox}>
    <div class="flex h-[348px] flex-col pt-8 md:h-50 md:pb-4 md:pt-4">
      <div class="pl-6 pr-6 text-black md:pl-10 md:pr-0">
        <h3 class="font-gotham-condensed text-h6-large md:text-[40px]">{link.title}</h3>
        <p class="pb-4 md:w-[282px] lg:w-full">{link.description}</p>
        <Button
          variant="filled"
          buttonClass="w-24 text-body-m-small !px-5"
          target="_blank"
          url="https://shop.obama.org/"
          label={link.cta}
        />
      </div>
      <img
        src={blackTee}
        class="absolute -bottom-1 -right-9 h-40 w-50 md:-bottom-10 md:-right-15 md:h-[255px] md:w-[308px]"
        alt="A black T-Shirt with the word 'Hope' written across the front in white text. The 'O' is the Obama Foundation logo."
      />
      <img
        src={stickerSet}
        class="absolute bottom-7 right-25 h-20 w-[70px] md:bottom-2 md:right-40 md:h-[123px] md:w-[111px]"
        alt="An Obama Foundation-themed sticker set"
      />
    </div>
  </WithPattern>
</a>
